/*
 *
 *	ENTRY POINT
 *  WEBPACK bundle APP
 *  client side
 */

// javascript bootstrap library
import 'bootstrap';
// bootstrap scss framework
import '../scss/framework.scss';



class Framework {

}



export default new Framework();